import React from 'react'

import { TopBar } from 'components/layouts/TopBar/TopBar'

export const DashboardTopBar = () => (
  <TopBar>
    <TopBar.UserProfile />
  </TopBar>
)
